const env = require('/opt/build/repo/twing/environment.js');
let templatesModule = (() => {
let module = {
    exports: undefined
};

module.exports = (TwingTemplate) => {
    return new Map([
        [0, class extends TwingTemplate {
            constructor(env) {
                super(env);

                this.source = this.getSourceContext();
                this.macros = new this.Context();
                let macros = new this.Context();

                this.parent = false;

                this.blocks = new Map([
                ]);
            }

            doDisplay(context, blocks = new Map()) {
                let macros = this.macros.clone();
                this.echo(this.include(context, this.source, this.loadTemplate(`7702abb215ba7a71fa8b10afcb7157eca3a49920518c7e427715a039e11204fc`, `7702abb215ba7a71fa8b10afcb7157eca3a49920518c7e427715a039e11204fc`, 1, 137), new Map([[`class`, `o-container--pad`]]), false, false, 1));
                this.echo(this.include(context, this.source, this.loadTemplate(`7702abb215ba7a71fa8b10afcb7157eca3a49920518c7e427715a039e11204fc`, `7702abb215ba7a71fa8b10afcb7157eca3a49920518c7e427715a039e11204fc`, 13, 138), new Map([[`class`, `o-container--pad`]]), false, false, 13));
            }

            getTemplateName() {
                return `7702abb215ba7a71fa8b10afcb7157eca3a49920518c7e427715a039e11204fc`;
            }

            isTraitable() {
                return false;
            }

            getSourceContext() {
                return new this.Source(``, `7702abb215ba7a71fa8b10afcb7157eca3a49920518c7e427715a039e11204fc`, ``);
            }
        }],
        [137, class extends TwingTemplate {
            constructor(env) {
                super(env);

                this.source = this.getSourceContext();
                this.macros = new this.Context();
                let macros = new this.Context();

                this.parent = this.loadTemplate(`@cloudfour/objects/container/container.twig`, `7702abb215ba7a71fa8b10afcb7157eca3a49920518c7e427715a039e11204fc`, 1);

                this.blocks = new Map([
                    ['content', [this, 'block_content']]
                ]);
            }

            doGetParent(context) {
                return `@cloudfour/objects/container/container.twig`;
            }

            doDisplay(context, blocks = new Map()) {
                let macros = this.macros.clone();
                this.parent.display(context, this.merge(this.blocks, blocks));
            }

            block_content(context, blocks = new Map()) {
                let macros = this.macros.clone();
                this.echo(`    <div style="padding-right: 50%">
      <div class="u-pad-n1" style="border: 2px solid">
        <p>This text will wrap: <strong>The quick brown
fox jumps over the lazy dog.</strong></p>
      </div>
    </div>
  `);
            }

            getTemplateName() {
                return `7702abb215ba7a71fa8b10afcb7157eca3a49920518c7e427715a039e11204fc`;
            }

            isTraitable() {
                return false;
            }

            getSourceContext() {
                return new this.Source(``, `7702abb215ba7a71fa8b10afcb7157eca3a49920518c7e427715a039e11204fc`, ``);
            }
        }],
        [138, class extends TwingTemplate {
            constructor(env) {
                super(env);

                this.source = this.getSourceContext();
                this.macros = new this.Context();
                let macros = new this.Context();

                this.parent = this.loadTemplate(`@cloudfour/objects/container/container.twig`, `7702abb215ba7a71fa8b10afcb7157eca3a49920518c7e427715a039e11204fc`, 13);

                this.blocks = new Map([
                    ['content', [this, 'block_content']]
                ]);
            }

            doGetParent(context) {
                return `@cloudfour/objects/container/container.twig`;
            }

            doDisplay(context, blocks = new Map()) {
                let macros = this.macros.clone();
                this.parent.display(context, this.merge(this.blocks, blocks));
            }

            block_content(context, blocks = new Map()) {
                let macros = this.macros.clone();
                this.echo(`    <div style="padding-right: 50%">
      <div class="u-pad-n1" style="border: 2px solid">
        <p>This text will not wrap: <strong class="u-text-no-wrap">The quick brown
fox jumps over the lazy dog.</strong></p>
      </div>
    </div>
  `);
            }

            getTemplateName() {
                return `7702abb215ba7a71fa8b10afcb7157eca3a49920518c7e427715a039e11204fc`;
            }

            isTraitable() {
                return false;
            }

            getSourceContext() {
                return new this.Source(``, `7702abb215ba7a71fa8b10afcb7157eca3a49920518c7e427715a039e11204fc`, ``);
            }
        }],
    ]);
};

    return module.exports;
})();

env.registerTemplatesModule(templatesModule, '7702abb215ba7a71fa8b10afcb7157eca3a49920518c7e427715a039e11204fc');

let template = env.loadTemplate('7702abb215ba7a71fa8b10afcb7157eca3a49920518c7e427715a039e11204fc');

module.exports = (context = {}) => {
    const rendered = template.render(context);
     const inputs = window.__twig_inputs__ || (window.__twig_inputs__ = new Map());
     inputs.set(
       rendered,
       { path: "@cloudfour/utilities/text/demo/nowrap.twig", args: context }
     );
     return rendered;;
};